// extracted by css-extract-rspack-plugin
export default {"QuestionBuilderWrapper":"question-builder_QuestionBuilderWrapper__axCMN","Header":"question-builder_Header__HBrx0","ButtonWrapper":"question-builder_ButtonWrapper__WWheB"};